import { Component } from '@angular/core';
import { IonicPage, NavController, NavParams, App } from 'ionic-angular';
import { ComplaintsProvider, Response } from '../../providers/complaints/complaints';
import { ComplaintsDetailsPage } from '../complaints-details/complaints-details';
import { AddComplaintsPage } from '../add-complaints/add-complaints';
import { UtilService } from '../../services/util';
import { TranslateService } from '@ngx-translate/core';
import { ToastProvider } from '../../providers/toast/toast';
import {StatusFilterPipe} from'../../pipes/status/status';

@IonicPage()
@Component({
  selector: 'page-open-complaints',
  templateUrl: 'open-complaints.html',
})
export class OpenComplaintsPage {

  params: any = {
    items: []
  };
  page_no: number = 1;
  complaint: any;
  message: string;
  enableRefresh = true;
  showData = false;
  selRegistrationLogin  : any;
 

  constructor(private app: App, public navCtrl: NavController, 
    public navParams: NavParams, 
    private translate: TranslateService,
    private toast: ToastProvider,
    private stpipe :StatusFilterPipe,
    private complaintsProvider: ComplaintsProvider,
    private util:UtilService
    ) {
     
      this.selRegistrationLogin = localStorage.getItem('signup_login')

      if(this.selRegistrationLogin){
        this.showData = true
        this.toast.presentToast("You are Unauthorized to use this feature , Please request to admin.");
      }
else{
    this.complaintsProvider.getComplaints("Open", this.page_no).then((res) => {
      
      this.showDetails(res);
      this.showData = true;
    }).catch(e => {
      console.log("--------------");
      console.log(e);
      this.util.showNoInternet();
      this.showData=true;
    });
  }

  }

  onItemClick(complaint: any){
    this.complaint = complaint;
    this.app.getRootNav().push(ComplaintsDetailsPage, {
      complaint: this.complaint,
      parentPage: this
    }
    );
  }
  showDetails(res: Response){
    if(res.data.length == 0){
      this.message = this.translate.instant("NO_MORE_RECORDS_FOUND");
      this.enableRefresh = false;
    }
    else{
      res.data.forEach(element => {
        // element.com_no = String(element.com_no).slice(4,);
        element.icon_img = "assets/images/complaints/"+element.complaint_type+".png";
        if(typeof element.data == "string"){
          element.data = JSON.parse(element.data);
        }
        if(this.stpipe.transform(element)){
          this.params.items.push(element);
         
        }  
      });
      this.page_no++;
      console.log(this.page_no);
      
    }
  }

  doInfinite(infiniteScroll) {
    this.complaintsProvider.getComplaints("Open",this.page_no).then(res => {
      this.showDetails(res);
      infiniteScroll.complete();
    });
  }

  doRefresh(refresher) {
    if(this.selRegistrationLogin){
      setTimeout(() => {
        this.showData = true;
        refresher.complete() 
        },2000)
    }
    else{
    this.page_no = 1;
    this.complaintsProvider.getComplaints("Open", this.page_no).then((res) => {
      this.params.items = [];
      this.showDetails(res);
      this.enableRefresh = true;
      this.message = "";
      refresher.complete();
    });
  }
  }

  refresh(){
    this.page_no = 1;
    this.complaintsProvider.getComplaints("Open", this.page_no).then((res) => {
      this.params.items = [];
      this.showDetails(res);
    });
  }

  ionViewDidLoad() {
    console.log('ionViewDidLoad OpenComplaintsPage');
  }

}



// WEBPACK FOOTER //
// ./src/pages/open-complaints/open-complaints.ts